<template>
    <v-layout fill-height column class="event-detail fill-sidebar grey lighten-2">
        <v-flex d-flex class="event-head-wrapper flex-grow-0" v-if="tabIndex !== 'event-map'">
            <event-head v-if="!isCallForm" v-bind:eventKey="activeEvent" @onSelect="showDetail(event)" v-bind:active="true"></event-head>
        </v-flex>
        <div v-if="isCallForm">
            <event-form :isCall="isCall"></event-form>
        </div>
        <v-flex v-if="event.id !== null" d-flex column class="event-detail-content overflow-auto">
            <v-tabs grow :hide-slider="true" background-color="grey lighten-2" class="event-detail-tabs" color="black"
                    v-if="visibleTabs"
                    active-class="grey lighten-2" ref="tabs" 
                    v-model="tabIndex"
            >
                <v-tabs-slider color="transparent"></v-tabs-slider>

                <!--MESSAGES TAB-->
                <v-tooltip top open-delay="400" v-for="(item, index) in conversations" :key="index">
                    <template v-slot:activator="{ on }">
                        <v-tab v-on="on" @click="onClick(item)" :active-class="messageCategories[item.type].color"
                               :href="'#event-messages-'+messageCategories[item.type].categoryId"
                               v-if="isTab('chat') && $can('view', 'Message')">
                            <v-badge :value="unvisitedByConversation(item).length > 0"
                                     offset-y="16px"
                                     offset-x="3px"
                                     :color="messageCategories[item.type].unreadClass"
                                     overlap
                                     :content="unvisitedByConversation(item).length">
                                <v-icon :size="tabIconSize">{{ chatIcon(item.type) }}</v-icon>
                            </v-badge>
                        </v-tab>
                    </template>
                    {{ item.label }}
                </v-tooltip>
                <v-tab-item :transition="false" v-for="(item, index) in conversations" :key="index"
                            :value="'event-messages-' + messageCategories[item.type].categoryId"
                            class="event-messages-tab-content">
                    <event-messages v-if="$can('view', 'Message')" :eventId="event.id"
                                    :conversation="item"></event-messages>
                </v-tab-item>

                <!--MAP TAB-->
                <v-tooltip top open-delay="400" v-if="isMobile">
                    <template v-slot:activator="{ on }">
                        <v-tab href="#event-map" v-on="on">
                            <v-icon size="22">map</v-icon>
                        </v-tab>
                    </template>
                    Mapa
                </v-tooltip>
                <v-tab-item v-if="isMobile" :transition="false" value="event-map" touchless>
                </v-tab-item>

                <!--CONTACTS TAB-->
                <v-tooltip top open-delay="400">
                    <template v-slot:activator="{ on }">
                        <v-tab href="#event-contacts" v-on="on"
                               v-if="isTab('contacts') && $can('view', 'EventContact')">
                            <v-icon size="22">$vuetify.icons.eventContacts</v-icon>
                        </v-tab>
                    </template>
                    Telefonní seznam
                </v-tooltip>
                <v-tab-item :transition="false" value="event-contacts" v-if="$can('view', 'EventContact')">
                    <event-contacts :event-key="event.uuid" :event-id="event.id"></event-contacts>
                </v-tab-item>

                <!--RESOURCES TAB-->
                <v-tooltip top open-delay="400">
                    <template v-slot:activator="{ on }">
                        <v-tab href="#event-resources" v-on="on"
                               v-if="isTab('event-jobs') && $can('view', 'EventResources')">
                            <v-icon size="22">$vuetify.icons.eventResources</v-icon>
                        </v-tab>
                    </template>
                    Technika
                </v-tooltip>
                <v-tab-item :transition="false" value="event-resources"
                            v-if="isTab('event-jobs') && $can('view', 'EventResources')">
                    <sidebar-event-jobs :event="event"></sidebar-event-jobs>
                </v-tab-item>

                <!--INFO TAB-->
                <v-tooltip top open-delay="400" v-if="!isMobile">
                    <template v-slot:activator="{ on }">
                        <v-tab v-if="isTab('form')" href="#event-info" v-on="on">
                            <v-badge class="align-self-center" color="error" offset-y="15" bordered right overlap
                                     v-model="isActiveEventChanged">
                                <template v-slot:badge>
                                    <v-icon size="9">$vuetify.icons.edited</v-icon>
                                </template>
                                <v-icon :size="tabIconSize">$vuetify.icons.eventInfo</v-icon>
                            </v-badge>
                        </v-tab>
                    </template>
                    Další nastavení
                </v-tooltip>

                <v-tab-item :transition="false" value="event-info">
                    <event-detail :allow-chat="false"></event-detail>
                </v-tab-item>

                <!--CHILD EVENTS TAB-->
                <v-tooltip top open-delay="400" v-if="!isMobile">
                    <template v-slot:activator="{ on }">
                        <v-tab href="#event-child" v-if="isTab('related')" v-on="on">
                            <v-icon>$vuetify.icons.eventCalls</v-icon>
                        </v-tab>
                    </template>
                    Historie akcí událostí
                </v-tooltip>
                <v-tab-item :transition="false" value="event-child">
                    <event-child-events ref="eventChild" :event="event"></event-child-events>
                </v-tab-item>

                <v-tooltip top open-delay="400" v-if="!isMobile">
                    <template v-slot:activator="{ on }">
                        <v-tab v-if="event.eventCategoryId === 17" :transition="false" :href="dzinEventUrl(event.code)" target="_blank" @click="returnTab" v-on="on">
                            DŽIN
                            <v-icon right>fas fa-arrow-up-right-from-square</v-icon>
                        </v-tab>
                    </template>
                    Otevře okno aplikace DŽIN/DSD v samostatné záložce prohlížeče
                </v-tooltip>

            </v-tabs>
        </v-flex>
        <map-component ref="map" v-if="tabIndex === 'event-map'" @onMapClose="tabIndex='event-contacts'"></map-component>

<!--        <v-btn fab fixed bottom left light>-->
<!--            <v-icon large>menu</v-icon>-->
<!--        </v-btn>-->

        <radio v-if="conversationType === 1 && $can('manage', 'Message1') && !isLocal(activeEvent)"
               :event-id="event.id"></radio>
        <capture-photo v-if="$can('manage', 'Message1') && !isLocal(activeEvent)"
                       :event-id="event.id"></capture-photo>
        <MessageForward v-bind:event="event"></MessageForward>
        <confirm-dialog ref="confirm" type="delete"></confirm-dialog>
        <list-events-for-link v-if="showLinkEventModal" :event="event"></list-events-for-link>
        <set-role-modal ref="setRoleModal" :event-id="event.id"></set-role-modal>
    </v-layout>
</template>

<script>

import {mapState, mapGetters, mapActions} from 'vuex'
import eventMessages from './Messages'
import eventHead from './Head'
import eventForm from './Form'
import eventDetail from './Detail'
import eventContacts from './Contacts'
import eventChildEvents from './ChildEvents'
import Radio from './MessageRadio'
import {forEach, includes, isEmpty} from "lodash";
import {appBus} from "@/main";
import {ADD_CONTACT_TO_EVENT, ADD_RESOLVER_CONTACT, SELECT_EVENT_TAB, SHOW_EVENT_VIEW} from "@/events";
import MessageForward from "@/components/panel/sidebar/event/MessageForward";
import SidebarEventJobs from "@/components/panel/sidebar/event/EventJobs";
import CapturePhoto from "@/components/camera/CapturePhoto";
import MapComponent from "@/components/map/Map";
import ListEventsForLink from "@/components/panel/sidebar/event/ListEventForLink.vue";
import SetRoleModal from "@/components/panel/sidebar/event/SetRoleModal.vue";

export default {
    name: 'sidebar-event',
    components: {
        SetRoleModal,
        ListEventsForLink,
        CapturePhoto,
        SidebarEventJobs,
        eventMessages,
        eventHead,
        eventDetail,
        eventForm,
        eventContacts,
        eventChildEvents,
        Radio,
        MessageForward,
        MapComponent,
        ConfirmDialog: () => import("@/components/ui/ConfirmDialog"),
    },
    created() {
        appBus.$on(ADD_CONTACT_TO_EVENT, (item) => {
            this.addContact(item);
        });

        appBus.$on(SELECT_EVENT_TAB, (tab) => {
            this.selectTab(tab);
        });

        appBus.$on(ADD_RESOLVER_CONTACT, () => {
           this.$refs.setRoleModal.open();
        });

    },
    data() {
        return {
            readAllDialog: false,
            delay: 200,
            clicks: 0,
            conversationType: 1,
            conversation: null,
            tabIconSize: 29,
            tabIndex: null,
        }
    },
    computed: {
        conversations() {
            let items = {};
            forEach(this.event.conversations, (conversation, conversationId) => {
              items[parseInt(conversationId)] = conversation;
            });
            return items;
        },
        isCallForm() {
            if (this.event.id === null)
                return true;

            if (this.event.id > 0 && includes(['chat', 'support'], this.eventCategory.type))
                return false;

            return includes(['call', 'chat', 'support'], this.eventCategory.type);
        },
        isCall() {
            return this.event.id === null || this.eventCategory.type === 'call' || this.eventCategory.type === 'data';
        },
        ...mapState({
            messageCategories: state => state.messages.categories,
            isMobile: state => state.isMobile,
            activeEvent: state => state.events.active,
            showLinkEventModal: state => state.events.showLinkEventModal,
        }),
        ...mapGetters('setup', {
            eventTypeOptions: 'eventTypeOptions',
        }),
        ...mapGetters('events', {
            isLocal: 'isLocal',
            canEditEvent: 'canEdit',
            isActiveEvent: 'isActiveEvent',
            event: 'getActiveEvent',
            isActiveEventChanged: 'isActiveEventChanged',
            isActive: 'isActive',
            dzinEventUrl: 'dzinEventUrl',
        }),
        ...mapGetters('eventJobs', {
            eventJobs: 'jobs',
        }),
        ...mapGetters('messages', {
          unvisitedByConversation: 'unvisitedByConversation',
        }),
        ...mapGetters('eventTypes', {
            getEventType: 'get',
        }),
        ...mapGetters('eventCategories', {
            getEventCategoryById: 'getEventCategoryById',
        }),
        eventCategory() {
            return this.getEventCategoryById(this.event.eventCategoryId);
        },
        eventStateId() {
            return this.event.eventStateId;
        },
        isEventStateActive() {
            return this.isActive(this.event.uuid);
        },
        visibleTabs() {
            return !isEmpty(this.eventCategory.tabs);
        }
    },
    methods: {
        ...mapActions('events', {
            cancel: 'cancelActiveEvent',
        }),
        ...mapActions('messages',
            {
                readEvent: 'readEvent',
                readConversation: 'readConversation',
            }
        ),
        returnTab() {
            const currentTab = this.tabIndex;
            this.timer = setTimeout(() => {
                this.selectTab(currentTab);
            }, 300);
        },
        onClick(currentConversation) {
            let lastConversation = this.conversation;
            this.conversation = currentConversation;

            if (lastConversation)
              this.onSetMessagesAsRead(lastConversation);
        },
        chatIcon(value) {
            if (value === 1)
                return `ter-gen-chat`
            return `ter-chat-${value+1}`
        },
        isTab(tab) {
            return this.eventCategory.tabs === null || this.eventCategory.tabs[tab] !== undefined;
        },
        async onSetMessagesAsRead(conversation) {
              let unvisited = this.unvisitedByConversation(conversation);
              if (unvisited.length > 0) {
                  await this.readConversation(conversation);
              }
        },
        addContact(item) {
            let payload = {
                eventId: this.event.id,
                contactTypeId: item.contactTypeId,
                name: item.name,
                number: item.number ? item.number.toString() : '',
                custom: 1,
            };
            this.$store.dispatch('eventContacts/save', payload).then(() => {
                // this.loading = false;
            });
        },
        showDetail(event) {
            appBus.$emit(SHOW_EVENT_VIEW, event);
        },
        setMessageCategory(value) {
            this.messageCategory = parseInt(value[1]);
        },
        selectTab(value) {
            this.tabIndex = value;
        }
    },
    watch: {
        tabIndex(val) {
            const regex = /event-messages-(\d+)/gm;
            let match = regex.exec(val);
            if (match) {
              const messageCategoryId = Number(match[1]);
              const messageCategory = Object.values(this.messageCategories).find(category => category.categoryId === messageCategoryId);
              this.conversation = Object.values(this.event.conversations).find(conv => conv.type === messageCategory.id);
              const input = document.getElementById('message-form-text-area-' + match[1])
                if (input) {
                    setTimeout(() => {
                        input.focus()
                    }, 50)
                }
            } else {
              if (this.conversation) {
                this.readConversation(this.conversation)
              }
              this.conversation = null;
            }
        },
      // conversation(conversation) {
      //     if (conversation)
      //       this.readConversation(conversation);
      // },
        isEventStateActive(val) {
            if (val === false) {
                if (this.event.parentId > 0) {
                    let event = this.$store.getters['events/byId'](this.event.parentId);
                    if (event && this.$store.getters['events/isActive'](event.uuid)) {
                        this.$store.dispatch('events/setActiveEvent', event.uuid);
                    } else {
                        this.$store.dispatch('events/setActiveEvent', false);
                    }

                } else {
                    this.$store.dispatch('events/setActiveEvent', false);
                }
            }
        },
        'event.eventRoles': {
            handler() {
                console.log('events/updatePermissions');
                this.$store.commit('events/updatePermissions');
            },
            deep: true
        }
    },
    beforeDestroy() {

        if (this.conversation)
          this.readConversation(this.conversation);

        appBus.$off(ADD_CONTACT_TO_EVENT);
        appBus.$off(SELECT_EVENT_TAB);
        appBus.$off(ADD_RESOLVER_CONTACT);
    }
}
</script>
